import { render, staticRenderFns } from "./defaultText.vue?vue&type=template&id=02064642&scoped=true"
import script from "./defaultText.vue?vue&type=script&lang=js"
export * from "./defaultText.vue?vue&type=script&lang=js"
import style0 from "./defaultText.vue?vue&type=style&index=0&id=02064642&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02064642",
  null
  
)

export default component.exports